import { Record } from 'immutable';

const DashboardFilterStateRecord = Record({
  completedAndUnpaid: true,
  missingAgency: true

});

export class DashboardFilterState extends DashboardFilterStateRecord {
  completedAndUnpaid: boolean;
  missingAgency: boolean;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/dashboard/dashboard-page/dashboard-filter.ts